export default {
  components: {
    searchInput: 'dt.invitesManager.components.searchInput',
    invitesManagerTabs: 'dt.invitesManager.components.invitesManagerTabs',
    addSelectionButton: 'dt.invitesManager.components.addSelectionButton',
    sendInviteButton: 'dt.invitesManager.components.sendInviteButton',
    clearButton: 'dt.invitesManager.components.clearButton',
    importButton: 'dt.invitesManager.components.importButton',
    inviteListCell: 'dt.invitesManager.components.inviteListCell',
    trashIcon: 'dt.invitesManager.components.trashIcon',
    searchButton: 'dt.invitesManager.components.searchButton',
    cancelButton: 'dt.invitesManager.components.cancelButton',
    selectedInviteSearch: 'dt.invitesManager.components.selectedInviteSearch',
    selectedInviteFilterButton: 'dt.invitesManager.components.selectedInviteFilterButton',
    drillDown: 'dt.invitesManager.components.drillDown',
    inviteListCellName: 'dt.invitesManager.components.inviteListCellName',
    sendReminderButton: 'dt.invitesManager.components.sendReminderButton',
    downloadButton: 'dt.invitesManager.components.downloadButton',
    copyInviteLinkButton: 'dt.invitesManager.components.copyInviteLinkButton',
    guide: {
      closeButton: 'dt.invitesManager.components.guide.closeButton',
    },
    invitesList: {
      emptyState: 'dt.invitesManager.components.invitesList.emptyState',
    },
    sectionTabs: {
      newTab: 'dt.invitesManager.components.sectionTabs.newTab',
      sentTab: 'dt.invitesManager.components.sectionTabs.sentTab',
    },
    sentSectionTab: {
      statCard: 'dt.invitesManager.components.sentSectionTab.statCard',
    },
    dataTable: {
      row: 'dt.invitesManager.components.dataTable.row',
      searchInput: 'dt.invitesManager.components.dataTable.searchInput',
    },
    modals: {
      addButton: 'dt.invitesManager.components.modals.addButton',
    },
    groupsSearch: 'dt.invitesManager.components.groupsSearch',
    ofpSearch: 'dt.invitesManager.components.ofpSearch',
  },
};
